export type CommentDiscloseScope = 'PUBLIC' | 'PRIVATE';

const PUBLIC = 'PUBLIC';
const PRIVATE = 'PRIVATE';

export const commentDiscloseScope: {
  PUBLIC: CommentDiscloseScope;
  PRIVATE: CommentDiscloseScope;
} = {
  PUBLIC,
  PRIVATE,
};
